var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMoney = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M24 17.5a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1v-11a1 1 0 0 1 1-1h22a1 1 0 0 1 1 1zm-3.651-1H22v-1.651a1.94 1.94 0 0 0-1.651 1.651m-2.006 0H5.654A4 4 0 0 0 2 12.873v-1.716A4 4 0 0 0 5.657 7.5h12.686A4 4 0 0 0 22 11.157v1.686a4 4 0 0 0-3.657 3.657M22 7.5v1.651A1.94 1.94 0 0 1 20.349 7.5zm-18.349 9A1.94 1.94 0 0 0 2 14.849V16.5zM2 7.5h1.651A1.94 1.94 0 0 1 2 9.151zm10 7.79A3.29 3.29 0 1 1 15.29 12 3.3 3.3 0 0 1 12 15.29m0-4.58a1.29 1.29 0 1 0 0 2.58 1.29 1.29 0 0 0 0-2.58",
  clipRule: "evenodd"
})));
export default SvgMoney;